import _objectWithoutProperties from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "active"];
import React, { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon, DotsVerticalIcon, EyeIcon } from '@heroicons/react/outline';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var DropdownMenuItem = function DropdownMenuItem(_ref) {
  var _children = _ref.children,
      active = _ref.active,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(Menu.Item, {
    children: function children(_ref2) {
      var active = _ref2.active;
      return /*#__PURE__*/_jsxs("button", {
        className: "".concat(active ? 'bg-brand-primary text-white' : 'text-gray-900', " group flex w-full items-center px-2 py-2 text-sm"),
        children: [/*#__PURE__*/_jsx(EyeIcon, {
          className: "text-brand-primary mr-2 w-5 group-hover:text-white"
        }), _children]
      });
    }
  });
};
export function DropdownMenu(_ref3) {
  var children = _ref3.children,
      label = _ref3.label;
  return /*#__PURE__*/_jsxs(Menu, {
    as: "div",
    className: "relative inline-block text-left",
    children: [/*#__PURE__*/_jsx(Menu.Button, {
      children: label ? /*#__PURE__*/_jsxs("div", {
        className: "flex items-center",
        children: [/*#__PURE__*/_jsx("span", {
          children: label
        }), /*#__PURE__*/_jsx(ChevronDownIcon, {
          className: "w-6 text-neutral-500"
        })]
      }) : /*#__PURE__*/_jsx("div", {
        className: "inline-flex items-center rounded-2xl p-2",
        children: /*#__PURE__*/_jsx(DotsVerticalIcon, {
          className: "z-0 w-6 text-black"
        })
      })
    }), /*#__PURE__*/_jsx(Transition, {
      as: Fragment,
      enter: "transition ease-out duration-100",
      enterFrom: "transform opacity-0 scale-95",
      enterTo: "transform opacity-100 scale-100",
      leave: "transition ease-in duration-75",
      leaveFrom: "transform opacity-100 scale-100",
      leaveTo: "transform opacity-0 scale-95",
      children: /*#__PURE__*/_jsx(Menu.Items, {
        className: "absolute right-0 z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none",
        children: children
      })
    })]
  });
}
export default DropdownMenu;